import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"
// import { Link } from "react-router-dom"
import styled from "styled-components"

import { Box, Typography } from "components/common"

// import infoNavData from "./data"

const InfoTitle = styled(Typography).attrs({ as: "h1" })`
  font-size: 26px;
  font-weight: 300;
  letter-spacing: 1px;
  margin-bottom: 18px;
  text-transform: capitalize;
  text-align: center;
`
// const InfoNavLink = styled(Box)`
//   font-size: 14px;
//   line-height: 2.3;
//   white-space: nowrap;
//   ${(props) => props.theme.mediaQueries.tablet`
//     font-size: 12px;
//     line-height: 1.5;
//   `}
//   :after {
//     display: inline-block;
//     content: "/";
//     margin: 0 8px;
//   }
//   :last-child:after {
//     display: none;
//   }
// `

const InfoLayout = ({ children, layout, title }) => {
  return (
    <div>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {layout && (
        <Box contain mt={4} px={{ _: "10px", tablet: 2 }}>
          <InfoTitle>{title}</InfoTitle>
        </Box>
      )}
      {children}
    </div>
  )
}

InfoLayout.propTypes = {
  children: PropTypes.element.isRequired,
  layout: PropTypes.string,
  title: PropTypes.string,
}

export default InfoLayout
